const PREFIX = "Shared/RequiredAttachment/";

export const RECEIVE_REQUIRED_ATTACHMENTS = `${PREFIX}RECEIVE_REQUIRED_ATTACHMENTS`;

export const REMOVE_REQUIRED_ATTACHMENTS = `${PREFIX}REMOVE_REQUIRED_ATTACHMENTS`;
